<template>
  <component
    :is="as"
    :class="[
      weight && weights[weight],
      {
        [sizes[size]]: size,
        [colors[color]]: color,
        [TEXT_STYLES[textStyle]]: textStyle,
        [WHITESPACES[whitespace]]: whitespace,
      },
    ]"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import {
  TEXT_STYLES,
  WHITESPACES,
} from '@shared/constants/ui/app-components-styles'
import {
  TextColors,
  TextSize,
  TextStyle,
  TextType,
  TextWeight,
  TextWhitespace,
} from '@shared/models/types/ui/app-text'

withDefaults(
  defineProps<{
    as?: TextType
    size?: TextSize
    weight?: TextWeight
    textStyle?: TextStyle
    color?: TextColors
    whitespace?: TextWhitespace
  }>(),
  {
    as: 'span',
    size: 'md',
    weight: undefined,
    color: 'secondary',
    textStyle: 'normal-case',
    whitespace: 'normal',
  }
)

const sizes: Record<TextSize, string> = {
  xxs: 'tw-text-xxs',
  xs: 'tw-text-xs',
  sm: 'tw-text-sm',
  md: 'tw-text-base',
  lg: 'tw-text-lg',
  xl: 'tw-text-xl',
  xxl: 'tw-text-2xl',
  xxxl: 'tw-text-3xl',
}

const weights: Record<TextWeight, string> = {
  extralight: 'tw-font-extralight',
  light: 'tw-font-light',
  regular: 'tw-font-normal',
  medium: 'tw-font-medium',
  semibold: 'tw-font-semibold',
  bold: 'tw-font-bold',
  extrabold: 'tw-font-extrabold',
  black: 'tw-font-black',
}

const colors: Record<TextColors, string> = {
  primary: 'tw-text-dynamic-primary',
  accent: 'tw-text-blue-400',
  secondary: 'tw-text-gray-3',
  warning: 'tw-text-orange-500',
  grayLight: 'tw-text-gray-light',
  primaryGray: 'tw-text-primary-gray',
  primaryBlack: 'tw-text-primary-black',
  black: 'tw-text-black',
  error: 'tw-text-red-500',
  white: 'tw-text-white',
  inherit: 'tw-text-inherit',
  success: 'tw-text-green-500',
  none: '',
}
</script>
